import BaseApiService from './BaseApiService';

class SettingApiService extends BaseApiService {
    constructor() {
        super('settings');
    }

    async getAll() {
        const response = await this.request({ method: 'get', url: '' });
        return response && response.settings ? response.settings : [];
    } 
    
    async update(data) {
        const response = await this.request({ method: 'patch', url: '', data });
        return response && response.settings ? response.settings : [];
    }
}

export default new SettingApiService();
